export const Arrow = ({ size = 18 }) => (
  <svg width={size} height={size * 0.66} viewBox="0 0 18 12" fill="none" stroke="currentColor" strokeWidth="1.6">
    <path d="M1 6h15M12 1l5 5-5 5" />
  </svg>
);

export const Check = ({ size = 13 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 7.5l3.4 3.4L12 3.5" />
  </svg>
);

export const InstagramIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none" />
  </svg>
);

export const TikTokIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.6 7.1a5.6 5.6 0 0 1-3.4-1.2 5.7 5.7 0 0 1-2-3.1h-3v12.6a2.6 2.6 0 1 1-2.6-2.6c.3 0 .5 0 .8.1V9.8a5.9 5.9 0 0 0-.8-.05 5.9 5.9 0 1 0 5.9 5.9V9.6a8.6 8.6 0 0 0 5.1 1.6V8.1c-.4 0 0-1 0-1z" />
  </svg>
);

export const FacebookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M14 8.5V6.8c0-.8.5-1 1-1h2.5V2.5H14c-2.8 0-4 2-4 4.1v1.9H7.5V12H10v9.5h4V12h2.7l.4-3.5H14z" />
  </svg>
);

export const TYPE_ICONS = {
  overthinker: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.5 3a2.5 2.5 0 0 0-2.5 2.5c-1.5.3-2.5 1.5-2.5 3 0 .6.2 1.2.5 1.7-.8.6-1.3 1.5-1.3 2.6 0 1.4.9 2.6 2.1 3 .1 1.8 1.6 3.2 3.4 3.2H10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-.5z" />
      <path d="M14.5 3a2.5 2.5 0 0 1 2.5 2.5c1.5.3 2.5 1.5 2.5 3 0 .6-.2 1.2-.5 1.7.8.6 1.3 1.5 1.3 2.6 0 1.4-.9 2.6-2.1 3-.1 1.8-1.6 3.2-3.4 3.2H14a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h.5z" />
    </svg>
  ),
  reactor: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2.5s1 2.5 3 4.5c2.1 2.1 3.5 4.2 3.5 6.8A6.5 6.5 0 0 1 12 20.5a6.5 6.5 0 0 1-6.5-6.7c0-2 1-3.8 2.2-5.2 0 0 .3 1.4 1.5 2.4C9.5 8.5 12 5.5 12 2.5z" />
    </svg>
  ),
  score: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 4h10v5a5 5 0 0 1-10 0V4z" />
      <path d="M7 5H4.5a1 1 0 0 0-1 1c0 2.2 1.6 4 3.7 4.4" />
      <path d="M17 5h2.5a1 1 0 0 1 1 1c0 2.2-1.6 4-3.7 4.4" />
      <line x1="12" y1="14" x2="12" y2="17.5" />
      <path d="M8.5 20.5h7M10 17.5h4v3h-4z" />
    </svg>
  ),
  pressure: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round">
      <circle cx="12" cy="12" r="7" />
      <circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none" />
      <line x1="12" y1="2" x2="12" y2="5.5" />
      <line x1="12" y1="18.5" x2="12" y2="22" />
      <line x1="2" y1="12" x2="5.5" y2="12" />
      <line x1="18.5" y1="12" x2="22" y2="12" />
    </svg>
  ),
  drifter: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round">
      <path d="M3.5 8h13" />
      <path d="M6 12h14.5" />
      <path d="M3.5 16h11" />
      <path d="M17.5 16h3" />
    </svg>
  ),
};
